"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunningBackDefendingUnit = void 0;
/**
 * The defending unit associated with a specific running back matchup.
 * @public
 */
var RunningBackDefendingUnit;
(function (RunningBackDefendingUnit) {
    /** Run defense */
    RunningBackDefendingUnit["RunDefense"] = "run-defense";
    /** Yards before contact */
    RunningBackDefendingUnit["YardsBeforeContact"] = "yards-before-contact-allowed";
    /** Yards after contact */
    RunningBackDefendingUnit["YardsAfterContact"] = "yards-after-contact-allowed";
    /** Missed tackle */
    RunningBackDefendingUnit["MissedTackle"] = "missed-tackle";
    /** Defensive front */
    RunningBackDefendingUnit["DefensiveFront"] = "defensive-front";
})(RunningBackDefendingUnit || (exports.RunningBackDefendingUnit = RunningBackDefendingUnit = {}));
//# sourceMappingURL=running_back_matchups.js.map